import React, { useState } from 'react';
import { supabase } from '../utils/supabase';

// Community puzzle intake ("Want to write the next Sr.?"). Shared by the Sr.
// result screens and the home page. Mirrors the FlagModal/ClaimModal pattern:
// POST to an api route that stores the idea and emails Matt.
// SIGNED-IN ONLY (Matt's call, 2026-08-06): the CTA shows to everyone, but
// signed-out clicks open the auth modal instead of this form, and the api
// route rejects tokenless posts - the UI gate is convenience, the token check
// is the enforcement.
const SubmitSrModal = ({ onClose }) => {
  const [opener, setOpener] = useState('');
  const [college, setCollege] = useState('');
  const [resume, setResume] = useState('');
  const [answer, setAnswer] = useState('');
  const [builtBy, setBuiltBy] = useState('');
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [err, setErr] = useState('');
  const canSend = opener.trim() && college.trim() && resume.trim() && answer.trim();

  const inputStyle = {
    width: '100%', padding: '10px 12px', background: '#111b30',
    border: '1px solid var(--border-dark)', borderRadius: 'var(--radius)',
    color: 'var(--text-white)', fontFamily: 'var(--font-body)',
    fontSize: '13px', marginBottom: '10px', boxSizing: 'border-box',
  };

  const handleSend = async () => {
    if (!canSend || sending) return;
    setSending(true); setErr('');
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.access_token) throw new Error('no session');
      const resp = await fetch('/api/sr-submission', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${session.access_token}`,
        },
        body: JSON.stringify({
          opener: opener.trim(), college: college.trim(),
          resume: resume.trim(), answer: answer.trim(),
          built_by: builtBy.trim() || null,
        }),
      });
      if (resp.status === 401) { setErr('You need an account to submit - sign up first.'); setSending(false); return; }
      if (!resp.ok) throw new Error('send failed');
      setSent(true);
    } catch (e) {
      setErr('Could not send - try again in a minute.');
    }
    setSending(false);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 999, padding: '20px',
    }}>
      <div style={{
        background: 'var(--bg-card)', border: '1px solid var(--border-dark)',
        borderRadius: 'var(--radius)', padding: '24px', width: '100%',
        maxWidth: '360px', maxHeight: '90vh', overflowY: 'auto',
      }}>
        {sent ? (
          <>
            <div style={{ textAlign: 'center', fontFamily: 'var(--font-heading)', fontSize: '20px', color: 'var(--green-correct)', letterSpacing: '2px', marginBottom: '8px' }}>✓ SENT</div>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '12px', color: 'var(--text-dim)', textAlign: 'center', marginBottom: '16px' }}>Matt will take a look. If your guy runs, you'll see him in the game.</p>
            <button className="btn btn-secondary" style={{ width: '100%' }} onClick={onClose}>CLOSE</button>
          </>
        ) : (
          <>
            <div style={{ fontFamily: 'var(--font-heading)', fontSize: '14px', letterSpacing: '2px', color: 'var(--gold)', marginBottom: '8px' }}>🧩 WRITE THE NEXT <span style={{ color: '#ff3b30', fontWeight: 900 }}>SR.</span></div>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '12px', color: 'var(--text-dim)', marginBottom: '16px' }}>Your prompt, your guy. If it runs, it's yours.</p>
            <textarea placeholder="Prompt (the opener - make it sing)" rows={3} value={opener} onChange={e => setOpener(e.target.value)} style={{ ...inputStyle, resize: 'vertical' }} autoFocus />
            <input type="text" placeholder="College" value={college} onChange={e => setCollege(e.target.value)} style={inputStyle} />
            <textarea placeholder={'Résumé (the hint after a second miss)'} rows={3} value={resume} onChange={e => setResume(e.target.value)} style={{ ...inputStyle, resize: 'vertical' }} />
            <input type="text" placeholder="Answer (the guy)" value={answer} onChange={e => setAnswer(e.target.value)} style={inputStyle} />
            <input type="text" placeholder="Built with love by... (your name)" maxLength={60} value={builtBy} onChange={e => setBuiltBy(e.target.value)} style={inputStyle} />
            {err && <p style={{ fontFamily: 'var(--font-body)', fontSize: '11px', color: 'var(--red-incorrect)', marginBottom: '8px' }}>{err}</p>}
            <div style={{ display: 'flex', gap: '8px' }}>
              <button className="btn btn-secondary" style={{ flex: 1 }} onClick={onClose}>CANCEL</button>
              <button className="btn btn-primary" style={{ flex: 1 }} onClick={handleSend} disabled={sending || !canSend}>{sending ? 'SENDING...' : 'SEND IT'}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SubmitSrModal;
